import { enMessages } from './en-US';

const esMessages = {
    "custom": {
        "teamEfficiency": "Eficiencia del equipo",
        "teamMembers": "Miembros del equipo",
        "dashboard": "Tablero",
        "planning": "Planificación",
        "info": "Información",
        "inventory": "Inventario",
        "notifications": "Notificaciones",
        "help": "Ayuda y soporte",
        "profile": "Perfil",
        "language": "Idioma",
        "trend": "Tendencia",
        "volume": "Volumen",
        "myTeam": "Mi equipo",
        "allTeams": "Todos los equipos",
        "teamCalendar": "Calendario del equipo",
        "saveChanges": "Guardar cambios",
        "cancel": "Cancelar",
        "warehouse": "Almacén De Café",
        "startFreeTrial": "Iniciar prueba gratuita",
        "buyNow": "Comprar ahora",
        "getSource": "Obtenga el código fuente en GitHub",
        "demoInfo": "Esta aplicación de demostración está construida utilizando los siguientes componentes de KendoReact y el tema Meridian de KendoReact.",
        "firstName": "Primer nombre",
        "middleName": "Segundo nombre",
        "lastName": "Apellido",
        "email": "Dirección de correo electrónico",
        "phoneNumber": "Número de teléfono",
        "country": "País",
        "biography": "Biografía corta",
        "public": "Incluir en directorio público",
        "team": "Equipo",
        "employee": "Empleado",
        "contactName": "Nombre de contacto",
        "jobTitle": "Título del trabajo",
        "salesRepresentative": "Representante de ventas",
        "status": "Estado",
        "performance": "Rendimiento",
        "rating":"Clasificación",
        "engagement": "Compromiso",
        "budget": "Presupuesto",
        "contacts": "Contactos",
        "address": "Dirección",
        "phone": "Teléfono",
        "gridSearch": "Buscar en todas las columnas ...",
        "exportExcel": "Exportar a Excel",
        "exportPdf": "Exportar a PDF",
        "inventoryItem1Description": "Etiopía Yirgacheffe, lavado, 60 kg",
        "inventoryItem2Description": "Colombia Huila, proceso honey, 60 kg",
        "inventoryItem3Description": "Bolsas kraft con válvula, 12 oz",
        "inventoryItem4Description": "Brasil Cerrado, natural, 60 kg",
        "inventoryItem5Description": "Tapas negras compostables, 1.000 unidades",
        "supplierHighlandOrigins": "Highland Origins",
        "supplierSierraVerde": "Sierra Verde",
        "supplierPacificPack": "Pacific Pack",
        "supplierFazendaDirect": "Fazenda Direct",
        "localeEnglish": "Inglés",
        "localeFrench": "Francés",
        "localeSpanish": "Español",
        "openNavigation": "Abrir navegación",
        "searchWarehouse": "Buscar en el almacén",
        "openNotifications": "Abrir notificaciones",
        "userAvatar": "Avatar de usuario",
        "dashboardTitle": "Panel del almacén",
        "dashboardDescription": "Supervise el rendimiento de preparación, la capacidad del equipo y los compromisos operativos.",
        "dashboardLastUpdated": "Última actualización: hace 5 minutos",
        "dashboardDataPeriod": "Periodo de ejemplo: ene.–abr. de 2020",
        "performanceSummary": "Resumen del rendimiento del almacén",
        "ordersShippedToday": "PEDIDOS ENVIADOS HOY",
        "ordersShippedDetail": "Al alza 8,4 % frente a ayer",
        "onTimeFulfillment": "PREPARACIÓN A TIEMPO",
        "onTimeFulfillmentDetail": "Al alza 1,2 puntos frente al objetivo",
        "pickQueue": "COLA DE PREPARACIÓN",
        "pickQueueDetail": "Al alza 9 pedidos requieren atención",
        "lowStockAlerts": "ALERTAS DE STOCK BAJO",
        "lowStockAlertsDetail": "Al alza 3 nuevos desde las 08:00",
        "teamEfficiencyDescription": "Ingresos de pedidos (USD) por equipo para el periodo seleccionado.",
        "teamMembersDescription": "Capacidad del equipo, compromiso y presupuesto operativo.",
        "teamTiger": "Equipo Tigre",
        "teamLemon": "Equipo Limón",
        "teamOrganic": "Equipo Orgánico",
        "teamOcean": "Equipo Océano",
        "schedulerTeams": "Equipos",
        "planningTitle": "Planificación del equipo",
        "planningDescription": "Asigne representantes de ventas a la actividad de pedidos programada.",
        "planningWorkWeek": "Semana laboral: 27 de abr. - 3 de may.",
        "planningDataPeriod": "Semana de ejemplo: 27 de abr.–3 de may. de 2020",
        "teamCalendarDescription": "Seleccione los miembros que desea incluir en el calendario compartido.",
        "includedInSchedule": "incluido en el calendario",
        "excludedFromSchedule": "excluido del calendario",
        "profileTitle": "Configuración del perfil",
        "profileDescription": "Administre sus datos de contacto y las preferencias del directorio del espacio de trabajo.",
        "emailPlaceholder": "p. ej.: peter@gmail.com",
        "inventoryTitle": "Gestión del inventario",
        "inventoryDescription": "Realice el seguimiento del café, el embalaje y los suministros del almacén en cada ubicación activa.",
        "inventoryLastUpdated": "Última actualización: 25 de ago. de 2026",
        "inventorySummary": "Resumen del inventario",
        "totalSkus": "TOTAL DE SKU",
        "totalSkusDetail": "Al alza 34 añadidos este trimestre",
        "lowStockItems": "ARTÍCULOS CON STOCK BAJO",
        "lowStockItemsDetail": "Al alza 3 requieren revisión hoy",
        "inventoryValue": "VALOR DEL INVENTARIO",
        "inventoryValueDetail": "A la baja 2,1 % frente al mes pasado",
        "inventoryOverview": "Resumen del inventario",
        "inventoryExplanation": "El stock disponible equivale a la cantidad disponible menos los pedidos comprometidos.",
        "createPurchaseOrder": "Crear pedido de compra",
        "searchInventory": "Buscar inventario",
        "searchInventoryPlaceholder": "Buscar SKU, proveedor o ubicación",
        "inventoryEmptyTitle": "No hay inventario que coincida con la búsqueda",
        "inventoryEmptyDescription": "Pruebe con otro SKU, proveedor o ubicación, o borre el filtro actual.",
        "clearInventorySearch": "Borrar búsqueda",
        "sku": "SKU",
        "itemDescription": "Descripción del artículo",
        "onHand": "Disponible",
        "reserved": "Reservado",
        "available": "Libre",
        "bin": "Ubicación",
        "supplier": "Proveedor",
        "stockStatus": "Estado del stock",
        "lastMovement": "Último movimiento",
        "outOfStock": "Agotado",
        "lowStock": "Stock bajo",
        "overstock": "Exceso de stock",
        "inStock": "En stock",
        "notificationsTitle": "Notificaciones",
        "notificationsDescription": "Revise las actualizaciones del almacén, las excepciones de stock y el trabajo programado.",
        "notificationsUnread": "3 no leídas",
        "notificationsSection": "Notificaciones del almacén",
        "notificationDeliveryTitle": "Entrega de Brasil Cerrado recibida",
        "notificationDeliveryDetail": "Se añadieron 42 sacos a la ubicación A-02-08.",
        "notificationDeliveryTime": "Hace 8 minutos",
        "notificationReceived": "Recibida",
        "notificationStockTitle": "El stock de bolsas kraft está por debajo del umbral",
        "notificationStockDetail": "P-02-11 no tiene unidades disponibles.",
        "notificationStockTime": "Hace 26 minutos",
        "notificationAttention": "Atención",
        "notificationReviewTitle": "La revisión semanal de preparación está pendiente",
        "notificationReviewDetail": "Confirme el plan de salida antes de las 16:00.",
        "notificationReviewTime": "Ayer, 09:15",
        "notificationScheduled": "Programada",
        "helpTitle": "Ayuda y soporte",
        "helpDescription": "Encuentre orientación sobre inventario, preparación y planificación del equipo.",
        "searchHelpTopics": "Buscar temas de ayuda",
        "searchHelpTopicsPlaceholder": "Buscar temas de ayuda",
        "helpPurchaseQuestion": "¿Cómo creo un pedido de compra?",
        "helpPurchaseAnswer": "En Inventario, seleccione Crear pedido de compra después de revisar el artículo y el proveedor afectados.",
        "helpLowStockQuestion": "¿Por qué un artículo aparece con stock bajo?",
        "helpLowStockAnswer": "Stock bajo indica que la cantidad disponible alcanzó el umbral de reposición después de aplicar las reservas.",
        "helpScheduleQuestion": "¿Cómo actualizo un calendario de equipo?",
        "helpScheduleAnswer": "Abra Planificación, seleccione al miembro y cree o ajuste una asignación en el planificador.",
        "notFoundTitle": "Error 404: página no encontrada",
        "notFoundDescription": "El espacio de trabajo del almacén solicitado no existe o se ha movido.",
        "goToDashboard": "Ir al panel principal",
        "online": "En línea",
        "offline": "Sin conexión",
        "validationEmail": "¡Ha introducido una dirección de correo electrónico no válida!",
        "validationRequired": "Este campo es obligatorio",
        "validationPhone": "Introduzca un número de teléfono válido.",
        "validationBiography": "La biografía debe tener al menos 50 caracteres.",
        "masterReactUi": "Domina el arte de la interfaz de React",
        "kendokaIllustration": "Ilustración de Kendoka",
        "githubIcon": "Icono de GitHub"
    },
    "datepicker": {
        "toggleCalendar": "Alternar calendario"
    },
    "calendar": {
        "today": "Hoy"
    },
    "dateinput": {
        "increment": "Incrementar valor",
        "decrement": "Disminuir valor"
    },
    "datetimepicker": {
        "date": "Fecha",
        "time": "Hora",
        "cancel": "Cancelar",
        "set": "Establecer"
    },
    "numerictextbox": {
        "increment": "Incrementar valor",
        "decrement": "Disminuir valor"
    },
    "timepicker": {
        "now": "AHORA",
        "set": "Establecer",
        "cancel": "Cancelar"
    },
    "grid": {
        "groupPanelEmpty": "Arrastre el título de una columna y suéltelo aquí para agrupar por ese criterio",
        "noRecords": "No hay datos disponibles.",
        "pagerFirstPage": "Ir a la primera página",
        "pagerPreviousPage": "Ir a la página anterior",
        "pagerNextPage": "Ir a la página siguiente",
        "pagerLastPage": "Ir a la última página",
        "pagerPage": "Página",
        "pagerOf": "de",
        "pagerItems": "ítems",
        "pagerInfo": "{0} - {1} de {2} ítems",
        "pagerItemsPerPage": "ítems por página",
        "filterEqOperator": "Es igual a",
        "filterNotEqOperator": "No es igual a",
        "filterIsNullOperator": "Es nulo",
        "filterIsNotNullOperator": "No es nulo",
        "filterIsEmptyOperator": "Está vacío",
        "filterIsNotEmptyOperator": "No está vacío",
        "filterStartsWithOperator": "Comienza con",
        "filterContainsOperator": "Contiene",
        "filterNotContainsOperator": "No contiene",
        "filterEndsWithOperator": "Termina en",
        "filterGteOperator": "Es mayor o igual que",
        "filterGtOperator": "Es mayor que",
        "filterLteOperator": "Es menor o igual que",
        "filterLtOperator": "Es menor o igual que",
        "filterIsTrue": "Sí",
        "filterIsFalse": "No",
        "filterBooleanAll": "(Todas)",
        "filterAfterOrEqualOperator": "Es posterior o igual a",
        "filterAfterOperator": "Es posterior",
        "filterBeforeOperator": "Es anterior",
        "filterBeforeOrEqualOperator": "Es anterior o igual a",
        "filterSubmitButton": "Filtrar",
        "filterClearButton": "Limpiar",
        "filterAndLogic": "Y",
        "filterOrLogic": "O",
        "filterTitle": "Filtros",
        "sortAscending": "Orden ascendente",
        "sortDescending": "Orden descendente"
    },
    "scheduler": {
        "editorValidationRequired": "El campo es obligatorio",
        "editorValidationStart": "La hora de inicio debe ser anterior a la hora de finalización",
        "editorValidationEnd": "La hora de finalización debe ser posterior a la hora de inicio",
        "allEvents": "Todos los eventos",
        "allDay": "todo el día",
        "today": "Hoy",
        "dayViewTitle": "Día",
        "weekViewTitle": "Semana",
        "monthViewTitle": "Mes",
        "workWeekViewTitle": "Semana laboral",
        "timelineViewTitle": "Línea de tiempo",
        "agendaViewTitle": "Agenda",
        "deleteTitle": "Eliminar",
        "previousTitle": "Anterior",
        "nextTitle": "Siguiente",
        "showFullDay": "Mostrar día completo",
        "showWorkDay": "Mostrar horario comercial",
        "editorOccurrence": "Editar ocurrencia actual",
        "editorSeries": "Editar la serie",
        "editorRecurringConfirmation": "¿Desea editar solo este evento o la serie completa?",
        "editorRecurringDialogTitle": "Editar elemento recurrente",
        "editorSave": "Guardar",
        "editorCancel": "Cancelar",
        "editorDelete": "Eliminar",
        "editorTitle": "Evento",
        "editorEventTitle": "Título",
        "editorEventStart": "Inicio",
        "editorEventStartTimeZone": "Zona horaria de inicio",
        "editorEventEnd": "Fin",
        "editorEventEndTimeZone": "Zona horaria final",
        "editorEventAllDay": "Evento de todo el día",
        "editorEventDescription": "Descripción",
        "editorEventSeparateTimeZones": "Finalizar en una zona horaria diferente",
        "editorEventTimeZone": "Especificar zona horaria",
        "recurrenceEditorRepeat": "Repetir",
        "recurrenceEditorDailyInterval": "día (s)",
        "recurrenceEditorDailyRepeatEvery": "Repetir cada",
        "recurrenceEditorWeeklyInterval": "week (s)",
        "recurrenceEditorWeeklyRepeatEvery": "Repetir cada",
        "recurrenceEditorWeeklyRepeatOn": "Repetir en",
        "recurrenceEditorMonthlyDay": "Día",
        "recurrenceEditorMonthlyInterval": "mes (es)",
        "recurrenceEditorMonthlyRepeatEvery": "Repetir cada",
        "recurrenceEditorMonthlyRepeatOn": "Repetir en",
        "recurrenceEditorYearlyOf": "de",
        "recurrenceEditorYearlyRepeatEvery": "Repetir cada",
        "recurrenceEditorYearlyRepeatOn": "Repetir en",
        "recurrenceEditorYearlyInterval": "año (s)",
        "recurrenceEditorFrequenciesDaily": "Diario",
        "recurrenceEditorFrequenciesMonthly": "Mensual",
        "recurrenceEditorFrequenciesNever": "Nunca",
        "recurrenceEditorFrequenciesWeekly": "Semanal",
        "recurrenceEditorFrequenciesYearly": "Anual",
        "recurrenceEditorOffsetPositionsFirst": "Primero",
        "recurrenceEditorOffsetPositionsSecond": "Segundo",
        "recurrenceEditorOffsetPositionsThird": "Tercero",
        "recurrenceEditorOffsetPositionsFourth": "Cuarto",
        "recurrenceEditorOffsetPositionsLast": "Último",
        "recurrenceEditorWeekdaysDay": "Día",
        "recurrenceEditorWeekdaysWeekday": "Día laborable",
        "recurrenceEditorWeekdaysWeekendday": "Día de fin de semana",
        "recurrenceEditorEndAfter": "Después",
        "recurrenceEditorEndOccurrence": "ocurrencias",
        "recurrenceEditorEndLabel": "Fin",
        "recurrenceEditorEndNever": "Nunca",
        "recurrenceEditorEndOn": "On",
        "deleteConfirmation": "¿Está seguro de que desea eliminar este evento?",
        "deleteRecurringConfirmation": "¿Desea eliminar solo este evento o la serie completa?",
        "deleteOccurrence": "Eliminar la ocurrencia actual",
        "deleteSeries": "Eliminar la serie",
        "deleteDialogTitle": "Eliminar evento",
        "deleteRecurringDialogTitle": "Eliminar elemento recurrente",
        "dateTitle": "Fecha",
        "timeTitle": "Tiempo",
        "eventTitle": "Evento",
        "noEvents": "sin eventos"
    }
};

const completeEsMessages = Object.keys(enMessages).reduce((messages, key) => ({
    ...messages,
    [key]: {
        ...enMessages[key],
        ...(esMessages[key] || {})
    }
}), {});

export { completeEsMessages as esMessages };